var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100vh d-flex flex-column justify-content-center align-items-center user-registeration"},[_c('stores')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }